<template>
  <div class="subscription-detail">
    <SubscriptionTable
      :headers="headers"
      :data="sanitizedItems"
      :loading="loading"
    ></SubscriptionTable>
  </div>
</template>

<script>
import SubscriptionTable from "@components/SubscriptionTable/SubscriptionTable.vue";
import { LD_FLAG_IDEA_MDP_560 } from "@components/constants/launchDarklyFlagKeys";
import { getListOfAccounts } from "@/api";
export default {
  name: "SubscriptionView",
  components: {
    SubscriptionTable,
  },
  data() {
    return {
      headers: [
        {
          text: "Account",
          sortable: false,
          value: "account",
        },
        {
          text: "Subscription",
          sortable: false,
          value: "subscription",
        },
        {
          text: "Period",
          sortable: false,
          value: "period",
        },
        {
          text: "Price",
          sortable: false,
          value: "price",
          centerField: true,
        },
        {
          text: "Status",
          sortable: false,
          value: "status",
          centerField: true,
        },
        {
          text: "",
          sortable: false,
          value: "actions",
        },
      ],
      accountItems: [],
      loading: false,
      skeletonLoadingEnabled: false,
    };
  },
  async mounted() {
    await this.checkSkeletonFlag();
    try {
      await this.loadAccounts();
    } catch (e) {
      console.log("e: ", e);
    }
  },
  computed: {
    sanitizedItems() {
      return this.accountItems.map((el) => {
        const newEl = {};
        newEl.id = el.id;
        newEl.account = el?.name || "";
        newEl.subscription = el?.subscription || "Unlimited";
        newEl.price = el?.price || 0;
        newEl.period = el?.period || "0";
        newEl.status = el?.status || "draft";
        return newEl;
      });
    },
  },
  methods: {
    async checkSkeletonFlag() {
      try {
        this.skeletonLoadingEnabled = (await this.$getFlag?.(LD_FLAG_IDEA_MDP_560, false)) === true;
      } catch (error) {
        this.skeletonLoadingEnabled = false;
      }
    },
    async loadAccounts() {
      this.loading = true;
      if (!this.skeletonLoadingEnabled) {
        this.$loader.show();
      }
      try {
        const { data } = await getListOfAccounts({ limit: 500, offset: 0 });
        this.accountItems = data.results;
      } finally {
        this.loading = false;
        if (!this.skeletonLoadingEnabled) {
          this.$loader.hide();
        }
      }
    },
  },
};
</script>

<style scoped>
.subscription-detail {
  border: 1px solid #eaecf0;
  padding: 1px;
  border-radius: 10px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
  height: 100%;
}
</style>
